// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"eeb9663c","453":"3845b555","796":"3f2785ce"}[chunkId] + ".chunk.js";
};